import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-mb-card"},[_c(VCol,{staticClass:"com-mb-card-contents pa-0"},[_c(VRow,{staticClass:"pa-2",attrs:{"no-gutters":""}},[_c('span',{staticClass:"pre-form"},[_c('a',{staticClass:"link fld-nav",attrs:{"href":_vm.floodedNav,"target":"_blank"},on:{"click":_vm.clickInuDetail}},[_vm._v(_vm._s(_vm.text.fldNav))])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }